import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import './accordion.scss';
import * as constant from '../../Corporate/dashboard/constant';
import DashboardAccordian from './dashboard-accordian/index';
import TreeStructure from './TreeStructure/index';
import '@nosferatu500/react-sortable-tree/style.css';

class Accordion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            'isCollapsed': false,
            treeData: [],
            enabled: false,
            switchValue: false
        }
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps) {
        if (this.props.switchValue !== prevProps.switchValue) {
            this.setState({
                switchValue: this.props.switchValue
            })
        }
        if (this.props.data !== prevProps.data) {
            if (this.props.titleData.clickedAside === constant.BUSINESSSEGMENT || this.props.titleData.clickedAside === constant.NICSEGMENT) {
                let tempData = []
                if (this.props.titleData.clickedAside === constant.BUSINESSSEGMENT){
                    tempData.push(this.props.allBusinessSegment);
                }
                tempData.push(this.props.data);
                this.setState({
                    treeData: tempData
                })
            }
        }
    }
    handleApplyFilter = (type, riskLevel) => {
        this.props.filter(type, riskLevel)
    }
    handleSwitchChange = (event) => {
        this.setState({
            switchValue: event.target.checked
        })
        setTimeout((checked) => {
            this.props.internationalFlagCallback(checked);
        }, 300, event.target.checked);

    }
    render() {
        let accordion = [];
        const { enabled } = this.state
        const { data } = this.props
        let allData = {};
        let dataFlag = false
        if (this.props.data) {
            if (Object.keys(this.props.data).length > 0) {
                dataFlag = true;
            }
        }
        return (
            <div className='accord tree-view' >
                {(this.props.titleData.clickedAside !== constant.BUSINESSSEGMENT && this.props.titleData.clickedAside !== constant.NICSEGMENT) ?
                    <div>{(dataFlag) ? (this.props.titleData.clickedAside === constant.GEOGRAPHY) ? <Row noGutters>
                        <Col sm='24'>
                            <Card className="accord-body border-0">
                                <CardBody className="p-0">
                                    <Row noGutters className="custom-table-header d-none d-sm-flex">
                                        <Col sm="6" className="custom-table-header-title p-3">{this.props.titleData.title}</Col>
                                        <Col sm="7" className="custom-table-header-title p-3 text-center">Rubix Average Score</Col>
                                        {/*<Col sm="6" className="custom-table-header-title p-3 text-center">No of Companies</Col>*/}
                                        <Col sm="6" className="custom-table-header-title p-3 text-center">Business Relations</Col>
                                        <Col sm="5" className="custom-table-header-title p-3">Switch</Col>
                                    </Row>
                                    <Row noGutters className="accord-header bg-light">
                                        <Col sm="6" className="p-3 accord-header__title border-bottom d-flex align-items-center">
                                            <span>{'ALL'}</span>
                                            <div className="d-flex flex-grow-1 pl-1 align-items-center justify-content-between d-sm-none">
                                                <span>Regions</span>
                                                <i data-toggle="collapse" data-target={'#Collapse' + 0} className='accord-header_mobile-btn-icon accord-header__btn-icon'></i>
                                            </div>
                                        </Col>
                                        <Col sm="7" xs="12" className="p-3 text-center accord-header__title border-bottom">
                                            {Number((this.state.switchValue) ? this.props.mapData['ALL_INTERNATIONAL'].avgScore : data['ALL_DOMESTIC'].avgScore).toFixed(0)}&nbsp;<span className="d-block d-sm-none">Average Score</span>
                                        </Col>
                                        {/*<Col sm="6" xs="12" className="p-3 text-center accord-header__title border-bottom border-right cursor-pointer" onClick={() => this.props.handleApplyFilter('ALL', '')}>
                                            {(this.state.switchValue) ? this.props.mapData['ALL_INTERNATIONAL'].numberOfCompanies : data['ALL_DOMESTIC'].numberOfCompanies}&nbsp;<span className="d-block d-sm-none">Companies</span>
                                        </Col>*/}
                                        <Col sm="6" xs="12" className="p-3 text-center accord-header__title border-bottom border-right cursor-pointer" onClick={() => this.props.filter('ALL', '', '', constant.COMPLETE, '', (this.state.switchValue) ? constant.INTERNATIONAL : constant.DOMESTIC)}>
                                            {(this.state.switchValue) ? this.props.mapData['ALL_INTERNATIONAL'].businessRelations : data['ALL_DOMESTIC'].businessRelations}&nbsp;<span className="d-block d-sm-none">Business Relations</span>
                                        </Col>
                                        {/* <Col sm="5" className="p-3 text-center accord-header__title border-bottom">Switch</Col> */}
                                        {/* <Col sm="2" data-toggle="collapse" onClick={this.handleAccordianButton} data-target={'#Collapse' + 0} className= 'p-3 text-right accord-header__title border-bottom'><i className="accord-header__btn-icon"></i></Col> */}
                                    </Row>
                                    <Row noGutters>
                                        <Col xs="6" className="p-3 d-flex align-items-center flex-column flex-sm-row border-right border-bottom-danger-4 risk-distribution" onClick={() => this.props.filter('ALL', constant.HIGH, '', constant.COMPLETE, '', (this.state.switchValue) ? constant.INTERNATIONAL : constant.DOMESTIC)}>
                                            <h3 className="mr-sm-3 risk-distribution__count">{(this.state.switchValue) ? this.props.mapData['ALL_INTERNATIONAL'].riskLevelMap.HIGH : data['ALL_DOMESTIC'].riskLevelMap.HIGH}</h3>
                                            <label className="risk-distribution__title text-center text-sm-left">High Risk</label>
                                        </Col>
                                        <Col xs="7" className="p-3 text-center align-items-center flex-column flex-sm-row border-right border-bottom-warning-4 risk-distribution" onClick={() => this.props.filter('ALL', constant.MEDIUM, '', constant.COMPLETE, '', (this.state.switchValue) ? constant.INTERNATIONAL : constant.DOMESTIC)}>
                                            <label className="risk-distribution__title text-center text-sm-left">
                                                <span className="mr-sm-3 risk-distribution__count">{(this.state.switchValue) ? this.props.mapData['ALL_INTERNATIONAL'].riskLevelMap.MEDIUM : data['ALL_DOMESTIC'].riskLevelMap.MEDIUM}</span>
                                                Moderate Risk</label>
                                        </Col>
                                        <Col xs="6" className="p-3 text-center align-items-center flex-column flex-sm-row border-bottom-success-4 border-right risk-distribution" onClick={() => this.props.filter('ALL', constant.LOW, '', constant.COMPLETE, '', (this.state.switchValue) ? constant.INTERNATIONAL : constant.DOMESTIC)}>
                                            <label className="risk-distribution__title text-center text-sm-left">
                                                <span className="mr-sm-3 risk-distribution__count">{(this.state.switchValue) ? this.props.mapData['ALL_INTERNATIONAL'].riskLevelMap.LOW : data['ALL_DOMESTIC'].riskLevelMap.LOW}</span>
                                                Low Risk</label>
                                        </Col>
                                        <Col xs='5' style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} className="p-3 d-flex align-items-center flex-column flex-sm-row risk-distribution">
                                            <div className="onoffswitch">
                                                <input type="checkbox" className="onoffswitch-checkbox" id="myonoffswitch" checked={this.state.switchValue} onChange={this.handleSwitchChange} />
                                                <label className="onoffswitch-label" htmlFor="myonoffswitch">
                                                    <span className="onoffswitch-inner"></span>
                                                    <span className="onoffswitch-switch"></span>
                                                </label>
                                            </div>
                                            {/* <div className='d-flex rounded'>
                                                <Switch theme="graphite-small" style={{ '--primaryColor': this.props.corporateColor.colorHexCode }} className="d-flex" enabled={enabled} onStateChanged={this.toggleNotifications} />
                                            </div> */}
                                        </Col>
                                        {/* <Col xs="2" className="p-3 d-flex align-items-center flex-column flex-sm-row border-bottom-success-4 risk-distribution" onClick={() => this.props.handleApplyFilter('ALL', constant.LOW)}>
                                            <label className="risk-distribution__title text-center text-sm-left">
                                                <span className="mr-sm-3 risk-distribution__count"></span>
                                            </label>
                                        </Col> */}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> : '' : ''}
                        {(!this.state.switchValue) && this.props.titleData.clickedAside !== constant.GEOGRAPHY ? <Row noGutters className="custom-table-header d-none d-sm-flex">
                            <Col sm="8" className="custom-table-header-title p-3">{this.props.titleData.title}</Col>
                            <Col sm="8" className="custom-table-header-title p-3 text-center">Rubix Average Score</Col>
                            {/*<Col sm="6" className="custom-table-header-title p-3 text-center">No of Companies</Col>*/}
                            <Col sm="6" className="custom-table-header-title p-3 text-center">Business Relations</Col>
                            <Col sm="2" className="custom-table-header-title p-3">
                            </Col>
                        </Row> : ''}</div> : ''
                }
                {
                    (this.props.titleData.clickedAside === constant.BUSINESSSEGMENT || this.props.titleData.clickedAside === constant.NICSEGMENT) ?
                        <TreeStructure treeData={this.state.treeData} {...this.props} handleApplyFilter={this.handleApplyFilter} handleMapFilter = {this.props.filter} /> :
                        <DashboardAccordian clickedAside={this.props.titleData.clickedAside} switchValue={this.props.switchValue} mapData={this.props.mapData} handleMapFilter = {this.props.filter} handleApplyFilter={this.handleApplyFilter} data={this.props.data} corporateColor={this.props.corporateColor} caseCountDataByState={this.props.caseCountDataByState} 
                        stateMapPreloader={this.props.stateMapPreloader} corporateId={this.props.corporateId}
                        />
                }

            </div >
        );
    }
}

export default Accordion;
